export function JustifyCenterIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.875 0.833008C11.3352 0.833008 11.7083 1.2061 11.7083 1.66634V4.16634C11.7083 4.62658 11.3352 4.99967 10.875 4.99967C10.4147 4.99967 10.0416 4.62658 10.0416 4.16634V1.66634C10.0416 1.2061 10.4147 0.833008 10.875 0.833008ZM10.875 7.49967C11.3352 7.49967 11.7083 7.87277 11.7083 8.33301V11.6663C11.7083 12.1266 11.3352 12.4997 10.875 12.4997C10.4147 12.4997 10.0416 12.1266 10.0416 11.6663V8.33301C10.0416 7.87277 10.4147 7.49967 10.875 7.49967ZM10.875 14.9997C11.3352 14.9997 11.7083 15.3728 11.7083 15.833V18.333C11.7083 18.7932 11.3352 19.1663 10.875 19.1663C10.4147 19.1663 10.0416 18.7932 10.0416 18.333V15.833C10.0416 15.3728 10.4147 14.9997 10.875 14.9997Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.875 4.99967H5.87504V7.49967H15.875V4.99967ZM5.87504 3.33301C4.95457 3.33301 4.20837 4.0792 4.20837 4.99967V7.49967C4.20837 8.42015 4.95457 9.16634 5.87504 9.16634H15.875C16.7955 9.16634 17.5417 8.42015 17.5417 7.49967V4.99967C17.5417 4.0792 16.7955 3.33301 15.875 3.33301H5.87504Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2083 12.4997H7.54167L7.54167 14.9997H14.2083V12.4997ZM7.54167 10.833C6.62119 10.833 5.875 11.5792 5.875 12.4997V14.9997C5.875 15.9201 6.62119 16.6663 7.54167 16.6663H14.2083C15.1288 16.6663 15.875 15.9201 15.875 14.9997V12.4997C15.875 11.5792 15.1288 10.833 14.2083 10.833H7.54167Z"
        fill="currentColor"
      />
    </svg>
  );
}
